<div [class.extra-small]="extraSmall" class="ac-toggle-container">
    <mat-slide-toggle [(ngModel)]="acModel" #matSlideToggle
                      (ngModelChange)="onChange($event)"
                      [disabled]="(ngDisabled || (acInputContainerComponent && acInputContainerComponent.isDisabled) || (acFormComponent && !acFormComponent.isAuthorized))?true:null"
                      color="primary"
                      [id]="toggleId">
        {{text}}
    </mat-slide-toggle>
</div>
